export default __webpack_public_path__ + "static/media/Bg-3.bbcb4e00.png";